export default __webpack_public_path__ + "static/media/hopes-and-fears-02.d09cd15c.jpg";